import React, { useState } from 'react';
import {
    AlertTriangle,
    Loader2,
    Trash2,
    X
} from 'lucide-react';

// ✅ Поправьте путь под вашу структуру
import MeteringNodeIcon from './../../../MeteringNodeIcon';

const DeleteNodeConfirmModal = ({ nodeName, onClose, onConfirm }) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const handleDelete = async () => {
        setIsDeleting(true);

        try {
            await onConfirm();
        } catch (err) {
            console.error(err);
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
            <div className="bg-slate-800 rounded-xl border border-slate-700 w-full max-w-md">
                <div className="px-4 py-3 border-b border-slate-700 flex items-center justify-between">
                    <h3 className="text-white font-semibold flex items-center gap-2">
                        <AlertTriangle className="w-5 h-5 text-red-400" />
                        Подтверждение удаления
                    </h3>

                    <button
                        onClick={onClose}
                        className="text-slate-400 hover:text-white"
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>

                <div className="p-4 space-y-3">
                    <p className="text-slate-300 text-sm">
                        Вы действительно хотите удалить узел учёта?
                    </p>

                    <div className="bg-slate-900 rounded-lg p-3">
                        <div className="flex items-center gap-2">
                            <MeteringNodeIcon className="w-6 h-6 text-blue-400" />
                            <span className="text-white font-semibold">{nodeName}</span>
                        </div>
                    </div>

                    <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-3">
                        <p className="text-red-300 text-xs flex items-start gap-2">
                            <AlertTriangle className="w-4 h-4 flex-shrink-0 mt-0.5" />

                            <span>
                                <strong>Внимание!</strong> Будут также удалены все связанные
                                устройства: тепловычислитель, датчики температуры, давления
                                и расходомеры. Это действие нельзя отменить.
                            </span>
                        </p>
                    </div>
                </div>

                <div className="px-4 py-3 border-t border-slate-700 flex justify-end gap-2">
                    <button
                        onClick={onClose}
                        disabled={isDeleting}
                        className="px-4 py-2 bg-slate-700 hover:bg-slate-600 text-white rounded-lg text-sm disabled:opacity-50"
                    >
                        Отмена
                    </button>

                    <button
                        onClick={handleDelete}
                        disabled={isDeleting}
                        className="px-4 py-2 bg-red-600 hover:bg-red-500 text-white rounded-lg text-sm flex items-center gap-2 disabled:opacity-50"
                    >
                        {isDeleting ? (
                            <>
                                <Loader2 className="w-4 h-4 animate-spin" />
                                Удаление...
                            </>
                        ) : (
                            <>
                                <Trash2 className="w-4 h-4" />
                                Удалить
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteNodeConfirmModal;